import BlockText from "../../block-content/block-text";
import styled from "styled-components";
import tw from "twin.macro";




const FAQBlock = (props) => {
  const faqBlock = props.props ?? props.pageBlockGroup;
  return (
    <section key={faqBlock._key} className="py-6 md:py-16">
      <div className="max-w-6xl px-4 mx-auto">
        <div className="md:w-8/12 mx-auto">
          {faqBlock.title && (
            <>
              <hr className="w-8 border-yellow-500 border-4 mb-2" />
              <h2 className="text-blue-500 font-bold tracking-tighter text-xl md:text-4xl mb-1 md:mb-3 leading-none tracking-tight">
                {faqBlock.title}
              </h2>
            </>
          )}
          {faqBlock.faqs &&
            faqBlock.faqs.map((faq) => (
              <Question key={faq._id} className="max-w-3xl text-blue-700 py-6">
                <div>
                  <BlockText blocks={faq._rawQuestion} key={faq._key} />
                </div>
                <Answer>
                  <div>
                    <BlockText blocks={faq._rawAnswer} key={faq._key} />
                  </div>
                </Answer>
              </Question>
            ))}
        </div>
      </div>
    </section>
  );
};

export default FAQBlock;

const Question = styled.div`
  p {
    ${tw`font-bold text-base md:text-lg mb-4`}
    &:first-child:before {
      content: "Q. ";
    }
  }
`;

const Answer = styled.div`
  p {
    ${tw`font-normal mb-6`}
    &:first-child:before {
      content: "A. ";
    }
  }
  ul {
    ${tw`text-base md:text-lg font-normal mb-6`}
    li {
      ${tw`list-disc list-inside`}
    }
  }
  a {
    ${tw`text-blue-500 underline hover:text-blue-700`}
  }
`;
